/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNewApplication = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13.414 1 20 7.586v3.422h-2V9h-6V3l-8 .007v18.001h6v2H2V1.01zm3.87 12.305c.614-.339.701-.387 1.165-.145l.267.145 2.982 2.981a1.014 1.014 0 0 1 0 1.434l-5.284 5.282H12v-4.414zM18 15.417l-4 4v1.585h1.585l4.001-4zm-8-.416v2H6v-2zm4-4v2H6v-2zm0-6.586V7h2.585z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNewApplication as NewApplication };
